import { gql } from '@apollo/client';

export type CreateChatMessageInput = {
  content: string;
  case_id: string;
  chat_id: string;
  role: string;
};

export type MessageDetails = {
  id: string;
  case_id: string;
  chat_id: string;
  content: string;
  role: string;
  created_date: string;
  created_by: string;
};

export const CREATE_CHAT_MESSAGE = gql`
  mutation CreateChatMessage($input: CreateChatMessageInput!) {
    createChatMessage(input: $input) {
      id
      case_id
      chat_id
      content
      role
    }
  }
`;
